import React, { useEffect, useRef, useState } from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { withViewport } from '../../util/contextHelpers';
import { types as sdkTypes } from '../../util/sdkLoader';
import axios from 'axios';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  FrontendPaginationLinks,
  Modal,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './ResearchWineries.module.css';
import SearchForm from './SearchForm/SearchForm';
import WineryRegionFilter from './SearchFilters/WineryRegionFilter';
import WineryCityFilter from './SearchFilters/WineryCityFilter';
import SortBySommlyScore from './SearchSortBy/SortBySommlyScore';
import SortByOtherCriteria from './SearchSortBy/SortByOtherCriteria';
import SortByVarietalsOffered from './SearchSortBy/SortByVarietalsOffered';
import SortByAnnualProduction from './SearchSortBy/SortByAnnualProduction';
import SearchResultCards from './SearchResultCards/SearchResultCards';
import MapGL from '../../components/Map/MapGL';
import Map from '../../components/Map/Map';
import { getAllWineries, searchWineries } from '../../services/winery';
import { getReigions } from '../../services/region';
import { getCities } from '../../services/city';
import { getVarietals } from '../../services/varietal';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { getMyFavorites } from '../../services/favorite';
import MboxMap from '../../components/Map/MboxMap';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import filterIcon from './filter.png';
import {
  changeSearchValueFilter,
  changeRegionFilter,
  changeCitiesFilter,
  changeSortByRatingFilter,
  changeVarietalsFilter,
  changeProductionRangeFilter,
  changeKidsFriendlyFilter,
  changeDogsFriendlyFilter,
  changeReservationsRequiredFilter,
  changeQualityScoreFilter,
  changeVarietyScoreFilter,
  changeAmbianceScoreFilter,
  changeAffordableScoreFilter,
  changeCustomerServiceScoreFilter,
  changeFoodOfferingsScoreFilter,
  changeStateValueFilter,
  changeWineriesFilter,
  changeWineriesToDisplayFilter,
  changeWineriesLoadingFilter,
  changeCurrentPageFilter,
  changePagesFilter,
} from './ResearchWineries.duck';
import WineryStateDropdownFilter from './SearchFilters/WineryStateDropdownFilter';

const { LatLng } = sdkTypes;
const MAX_MOBILE_SCREEN_WIDTH = 768;

const ResearchWineriesPage = ({
  currentUser,
  location,
  viewport,
  onManageDisableScrolling,
  searchValue,
  onChangeSearchTxt,
  onChangeRegions,
  selectedRegions,
  selectedCities,
  onChangeCities,
  onChangeSortByRating,
  selectedScore,
  selectedvarietal,
  setSelectedvarietal,
  setSelectedProductionRnage,
  selectedProductionRange,
  kidsFriendly,
  setKidsFriendly,
  dogsFriendly,
  setDogsFriendly,
  reservationsRequired,
  setReservationsRequired,
  qualityScore,
  setQualityScore,
  varietyScore,
  setVarietyScore,
  ambianceScore,
  setAmbianceScore,
  affordableScore,
  setAffordableScore,
  customerServiceScore,
  setCustomerServiceScore,
  foodOfferingsScore,
  setFoodOfferingsScore,
  stateValue,
  setStateValue,
  wineries,
  wineriesToDisplay,
  wineriesLoading,
  setWineriesLoading,
  setWineriesToDisplay,
  setWineries,
  pages,
  setPages,
  currentPage,
  setCurrentPage,
}) => {
  const mountedRef = useRef(true);
  // keyword search value from search query
  const searchKeywords = location.search ? location.search.split('=')[1] : '';
  // states

  const setSearchVlaue = vl => {
    onChangeSearchTxt(vl);
  };

  const [selectedState, setSelectedState] = useState("");
  const [regions, setRegions] = useState([]);
  const [regionsLoading, setRegionsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [citiesLoading, setCitiesLoading] = useState([]);
  const [varietals, setVarietals] = useState([]);
  const [varietalsLoading, setVarietalsLoading] = useState([]);

  const [favWineries, setFavWineries] = useState([]);
  const [myFavs, setMyFavs] = useState(new Set());
  const [openMobileFilter, setOpenMobileFilter] = useState(false);

  // Pagination
  const wineriesPerPage = 8;
  const [selected, setSelected] = useState(false);
  // filteration
  const onFilterWineries = (value, type) => {
    if(type === 'state'){
      onChangeRegions([]);
      setSelectedState(value);
    }
    else if(type === 'regions')
    {
      onChangeRegions(value);
    }
  }

  const filterWineries = () => {
    let tempWineries = wineries;
    // Filter by State
    if(selectedState !== ""){
      tempWineries = tempWineries.filter(winery => winery.state !== null && winery.state.toLowerCase() === selectedState.toLowerCase());
    }

    // Filter by Region
    if (selectedRegions.length > 0) {
      let tempRegionsWineries = [];
      selectedRegions.forEach(r => {
        tempRegionsWineries = [ ...tempRegionsWineries, ...tempWineries.filter(winery => winery.region.toLowerCase() === r.toLowerCase())];
      });
      tempWineries = tempRegionsWineries;
    }

    // Filter by Quality Score
    if(qualityScore !== "" && qualityScore !== 0)
    {
      tempWineries = tempWineries.filter(element => {
        if (element.searchMeta.metaData.quality !== undefined) {
          if (element.searchMeta.metaData.quality >= qualityScore) {
            return true;
          } else {
            return false;
          }
        } 
        else if(qualityScore <= 1) {
          return true;
        }
        else {
          return false;
        }
      });
    }
    
    // Filter by Variety Score
    if(varietyScore !== "" && varietyScore !== 0)
    {
      tempWineries = tempWineries.filter(element => {
        if (element.searchMeta.metaData.variety !== undefined) {
          if (element.searchMeta.metaData.variety >= varietyScore) {
            return true;
          } else {
            return false;
          }
        } 
        else if(varietyScore <= 1) {
          return true;
        }
        else {
          return false;
        }
      });
    }
    
    // Filter by Ambiance Score
    if(ambianceScore !== "" && ambianceScore !== 0)
    {
      tempWineries = tempWineries.filter(element => {
        if (element.searchMeta.metaData.venueAmbiance !== undefined) {
          if (element.searchMeta.metaData.venueAmbiance >= ambianceScore) {
            return true;
          } else {
            return false;
          }
        } 
        else if(ambianceScore <= 1) {
          return true;
        }
        else {
          return false;
        }
      });
    }
    
    // Filter by Affordable Score
    if(affordableScore !== "" && affordableScore !== 0)
    {
      tempWineries = tempWineries.filter(element => {
        if (element.searchMeta.metaData.affordable !== undefined) {
          if (element.searchMeta.metaData.affordable >= affordableScore) {
            return true;
          } else {
            return false;
          }
        } 
        else if(affordableScore <= 1) {
          return true;
        }
        else {
          return false;
        }
      });
    }
    
    // Filter by Customer Service Score
    if(customerServiceScore !== "" && customerServiceScore !== 0)
    {
      tempWineries = tempWineries.filter(element => {
        if (element.searchMeta.metaData.customerService !== undefined) {
          if (element.searchMeta.metaData.customerService >= customerServiceScore) {
            return true;
          } else {
            return false;
          }
        } 
        else if(customerServiceScore <= 1) {
          return true;
        }
        else {
          return false;
        }
      });
    }
    
    // Filter by Food Offering Score
    if(foodOfferingsScore !== "" && foodOfferingsScore !== 0)
    {
      tempWineries = tempWineries.filter(element => {
        if (element.searchMeta.metaData.foodOfferings !== undefined) {
          if (element.searchMeta.metaData.foodOfferings >= foodOfferingsScore) {
            return true;
          } else {
            return false;
          }
        } 
        else if(foodOfferingsScore <= 1) {
          return true;
        }
        else {
          return false;
        }
      });
    }

    // Filter by  Kids Friendly
    if(kidsFriendly)
    {
      tempWineries = tempWineries.filter(w => w?.searchMeta.kidFriendly === true);
    }
    
    // Filter by Dog Friendly
    if(dogsFriendly)
    {
      tempWineries = tempWineries.filter(w => w?.searchMeta.dogFriendly === true);
    }
    
    // Filter by Is Reservation Required
    if(reservationsRequired)
    {
      tempWineries = tempWineries.filter(w => w?.searchMeta.reservationsRequired === true);
    }

    // Filter by Annual Production
    if (selectedProductionRange.length > 0) {
      let tempProductionWineries = [];
      selectedProductionRange.forEach(r => {
        tempProductionWineries = [...tempProductionWineries, ...tempWineries.filter(winery => winery.searchMeta.production_range === r)];
      });
      tempWineries = tempProductionWineries;
    }

    // Filter by n
    if (selectedvarietal.length > 0) {
      console.log(selectedvarietal, tempWineries);
      let tempVarietalWineries = [];
      selectedvarietal.forEach(v => {
        tempVarietalWineries = [...tempVarietalWineries, ...tempWineries.filter(winery => winery.searchMeta.varietals_bottled.includes(v))];
      });
      tempWineries = tempVarietalWineries;
      console.log("Filtered: ", tempWineries);
    }

    setWineriesToDisplay(tempWineries);
  }
    

  useEffect(() => {
    filterWineries();
  },[selectedState, selectedRegions, qualityScore, varietyScore, ambianceScore, affordableScore, customerServiceScore, foodOfferingsScore, kidsFriendly, dogsFriendly, reservationsRequired, selectedProductionRange, selectedvarietal])

  useEffect(() => {
    // map location coordinates list
    if (wineriesToDisplay.length > 0) {
      let tempLocation = [];
      wineriesToDisplay.forEach(w => {
        const obj = {
          id: w._id,
          slug: w.slug,
          name: w.name,
          city: w.city,
          address: w.street,
          state: w.state,
          lat: Number(w.lat),
          lng: Number(w.lng),
        };
        tempLocation = [...tempLocation, obj];
      });
      setLocations(tempLocation);
    } else {
      setLocations([]);
    }

    // pagination actions
    if (wineriesToDisplay.length > 0) {
      setPages(Math.round(wineriesToDisplay.length / wineriesPerPage));
    } else {
      setPages(0);
    }

  }, [wineriesToDisplay]);

  const setSelectedScore = selectedScore => {
    onChangeSortByRating(selectedScore);
  };
  // map state
  const [locations, setLocations] = useState(null);

  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
  // const isMobileMenuOpen = isMobileLayout && mobilemenu === 'open';
  // const isMobileSearchOpen = isMobileLayout && mobilesearch === 'open';
  //  useeffect to get wineries
  useEffect(() => {
    getAllNeededDataOnMount();
    return () => {
      mountedRef.current = false; // clean up function
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setSelected(true);
    }, 5000);
  }, []);

  const getAllNeededDataOnMount = async () => {
    await getReigions(setRegionsLoading, setRegions);
    await getCities(setCitiesLoading, setCities);
    await getVarietals(setVarietals, setVarietalsLoading);
    if (wineries.length === 0) {
      await searchWineries(searchKeywords, setWineriesLoading, setWineries);
    }
  };

  useEffect(() => {
    if (currentUser) {
      getMyFavorites(currentUser?.expresUserId, setFavWineries);
    }
  }, [currentUser]);

  useEffect(() => {
    if (favWineries.length > 0) {
      const tempFavs = new Set();
      favWineries.forEach(fav => {
        tempFavs.add(fav.winery?._id);
      });
      setMyFavs(tempFavs);
    }
  }, [favWineries]);

  const handleSearchSubmit = async e => {
    e.preventDefault();

    await searchWineries(searchValue, setWineriesLoading, setWineries);
    setWineriesToDisplay(wineries);
  };

  useEffect(() => {
    if (wineriesToDisplay.length == 0) {
      filterWineries();
    }
  }, [wineries]);

  useEffect(() => {
    if (selected) {
      if (selectedScore) {
        const temp = wineries.sort((a, b) => {
          if (selectedScore === 'high') {
            return a?.score - b?.score;
          } else if (selectedScore === 'low') {
            return b?.score - a?.score;
          }
        });
        setWineriesToDisplay(temp);
      } else {
        setWineriesToDisplay(wineries);
      }
    }
  }, [selectedScore]);

  const handleOnChangeLocalfruit = e => {
    if (selected) {
      if (e.target.checked) {
        const tempWineries = wineries.filter(w => w?.searchMeta.local_state_fruit === true);
        setWineriesToDisplay(tempWineries);
      } else {
        setWineriesToDisplay(wineries);
      }
    }
  };

  
  const handleMpbileFilterClose = () => {
    setOpenMobileFilter(false);
  };

  const goToNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const changePage = event => {
    const pageNumber = Number(event.target.textContent);
    setCurrentPage(pageNumber);
  };

  const getPaginatedData = () => {
    if (wineriesToDisplay.length >= 8) {
      const startIndex = currentPage * wineriesPerPage - wineriesPerPage;
      const endIndex = startIndex + wineriesPerPage;
      return wineriesToDisplay.slice(startIndex, endIndex);
    } else {
      return wineriesToDisplay;
    }
  };

  const paginationLinks =
    pages > 1 ? (
      <FrontendPaginationLinks
        className={css.pagination}
        pagination={{
          page: currentPage,
          perPage: wineriesPerPage,
          totalItems: wineries.length,
          totalPages: pages,
        }}
        goToNextPage={goToNextPage}
        goToPreviousPage={goToPreviousPage}
        changePage={changePage}
      />
    ) : null;

  const renderSearchFilter = () => (
    <div className={css.searchFilterWrapper}>
      <WineryStateDropdownFilter
        handleChange={onFilterWineries}
      />

      <WineryRegionFilter
        regions={regions}
        selectedRegions={selectedRegions}
        selectedState={selectedState}
        handleChange={onFilterWineries}
      />
      {/* <WineryCityFilter
        cities={cities}
        setCities={setCities}
        setCitiesLoading={setCitiesLoading}
        selectedCities={selectedCities}
        setSelectedCities={setSelectedCities}
      /> */}
      <SortByOtherCriteria
        handleOnChangeLocalfruit={handleOnChangeLocalfruit}
        setReservationsRequired={setReservationsRequired}
        setDogsFriendly={setDogsFriendly}
        setKidsFriendly={setKidsFriendly}
        kidsFriendly={kidsFriendly}
        dogsFriendly={dogsFriendly}
        reservationsRequired={reservationsRequired}
        wineries={wineries}
        setWineriesToDisplay={setWineriesToDisplay}
        qualityScore={qualityScore}
        setQualityScore={setQualityScore}
        varietyScore={varietyScore}
        setVarietyScore={setVarietyScore}
        ambianceScore={ambianceScore}
        setAmbianceScore={setAmbianceScore}
        affordableScore={affordableScore}
        setAffordableScore={setAffordableScore}
        customerServiceScore={customerServiceScore}
        setCustomerServiceScore={setCustomerServiceScore}
        foodOfferingsScore={foodOfferingsScore}
        setFoodOfferingsScore={setFoodOfferingsScore}
        selected={selected}
      />
      <SortByVarietalsOffered
        varietals={varietals}
        setVarietals={setVarietals}
        setVarietalsLoading={setVarietalsLoading}
        selectedvarietal={selectedvarietal}
        setSelectedvarietal={setSelectedvarietal}
      />
      <SortByAnnualProduction
        selectedProductionRange={selectedProductionRange}
        setSelectedProductionRnage={setSelectedProductionRnage}
      />
    </div>
  );

  return (
    <StaticPage
      title="Research Wineries"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ResearchWineriesPage',
        description: 'Research Wineries',
        name: 'Research Wineries',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>
            <div className={css.layoutWrapperHeader}>
              <div className={css.overlay} />
              <div className={css.headerContent}>
                <h1>Research Wineries</h1>
                <SearchForm
                  handleSubmit={handleSearchSubmit}
                  searchValue={searchValue}
                  setSearchVlaue={setSearchVlaue}
                  rootClassName={css.searchBarWrapper}
                  searchBarIcon={css.searchIcon}
                  searchBarClassName={css.searchBar}
                  placeholder="Winery, Varietal, Wine Region, State, or City..."
                />
              </div>
            </div>

            <div className={css.searchContainerWrapper}>
              <div className={css.searchContainer}>
                <div className={css.searchFilterDesktop}>{renderSearchFilter()}</div>
                <div className={css.searchResultWrapper}>
                  <div className={css.searchResultTop}>
                    <button className={css.filterBtn} onClick={() => setOpenMobileFilter(true)}>
                      <img src={filterIcon} alt="" />
                      <h2>Filter</h2>
                    </button>
                    <h2>{wineriesToDisplay?.length} Result/s</h2>
                  </div>
                  <SortBySommlyScore
                    selectedScore={selectedScore}
                    setSelectedScore={setSelectedScore}
                  />

                  <div>
                    <div
                      style={{
                        width: '100%',
                        height: isMobileLayout ? '200px' : '335px',
                        margin: '30px 0 70px',
                      }}
                    >
                      {/* <MapGL
                        locations={locations}
                        zoom={6}
                        latitude={31.9686}
                        longitude={-99.9018}
                        showLink={true}
                      /> */}
                      <MboxMap
                        center={locations !== null && locations.length > 0 ? new LatLng(locations[0].lat, locations[0].lng) : new LatLng(31.9686, -99.9018)}
                        zoom={isMobileLayout ? selectedState !== "" ? 3 : 1 : selectedState !== "" ? 4 : 2}
                        locations={locations}
                      />
                    </div>
                    <SearchResultCards
                      wineries={getPaginatedData}
                      wineriesLoading={wineriesLoading}
                      myFavs={myFavs}
                    />
                  </div>
                  <div>{paginationLinks}</div>
                </div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>

      <Modal
        id="ResearchWineryMobileFilterSort"
        isOpen={openMobileFilter}
        onClose={handleMpbileFilterClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div style={{ margin: '10px 0 30px' }}>{renderSearchFilter()}</div>
      </Modal>
    </StaticPage>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
    searchValue: state.ResearchWineries.searchValue,
    selectedRegions: state.ResearchWineries.selectedRegions,
    selectedCities: state.ResearchWineries.selectedCities,
    selectedScore: state.ResearchWineries.selectedScore,
    selectedvarietal: state.ResearchWineries.selectedVarietals,
    selectedProductionRange: state.ResearchWineries.productionRange,
    kidsFriendly: state.ResearchWineries.kidsFriendly,
    dogsFriendly: state.ResearchWineries.dogsFriendly,
    reservationsRequired: state.ResearchWineries.reservationsRequired,
    qualityScore: state.ResearchWineries.qualityScore,
    varietyScore: state.ResearchWineries.varietyScore,
    ambianceScore: state.ResearchWineries.ambianceScore,
    affordableScore: state.ResearchWineries.affordableScore,
    customerServiceScore: state.ResearchWineries.customerServiceScore,
    foodOfferingsScore: state.ResearchWineries.foodOfferingsScore,
    stateValue: state.ResearchWineries.stateValue,
    wineries: state.ResearchWineries.wineries,
    wineriesToDisplay: state.ResearchWineries.wineriesToDisplay,
    wineriesLoading: state.ResearchWineries.wineriesLoading,
    pages: state.ResearchWineries.pages,
    currentPage: state.ResearchWineries.currentPage,
  };
};
const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onChangeRegions: regions => dispatch(changeRegionFilter(regions)),
  onChangeCities: cities => dispatch(changeCitiesFilter(cities)),
  onChangeSearchTxt: searchTxt => dispatch(changeSearchValueFilter(searchTxt)),
  onChangeSortByRating: sort => dispatch(changeSortByRatingFilter(sort)),
  setSelectedProductionRnage: productionRange =>
    dispatch(changeProductionRangeFilter(productionRange)),
  setKidsFriendly: kidsFriendly => dispatch(changeKidsFriendlyFilter(kidsFriendly)),
  setDogsFriendly: dogsFriendly => dispatch(changeDogsFriendlyFilter(dogsFriendly)),
  setReservationsRequired: productionRange =>
    dispatch(changeReservationsRequiredFilter(productionRange)),
  setQualityScore: qualityScore => dispatch(changeQualityScoreFilter(qualityScore)),
  setVarietyScore: varietyScore => dispatch(changeVarietyScoreFilter(varietyScore)),
  setAmbianceScore: ambianceScore => dispatch(changeAmbianceScoreFilter(ambianceScore)),
  setAffordableScore: affordableScore => dispatch(changeAffordableScoreFilter(affordableScore)),
  setCustomerServiceScore: customerServiceScore =>
    dispatch(changeCustomerServiceScoreFilter(customerServiceScore)),
  setFoodOfferingsScore: foodOfferingsScore =>
    dispatch(changeFoodOfferingsScoreFilter(foodOfferingsScore)),
  setStateValue: StateValue => dispatch(changeStateValueFilter(StateValue)),
  setSelectedvarietal: selectedvarietal => dispatch(changeVarietalsFilter(selectedvarietal)),
  setWineries: wineries => dispatch(changeWineriesFilter(wineries)),
  setWineriesToDisplay: wineriesToDisplay =>
    dispatch(changeWineriesToDisplayFilter(wineriesToDisplay)),
  setWineriesLoading: wineriesLoading => dispatch(changeWineriesLoadingFilter(wineriesLoading)),
  setPages: pages => dispatch(changePagesFilter(pages)),
  setCurrentPage: page => dispatch(changeCurrentPageFilter(page)),
});

export default compose(
  withRouter,
  withViewport,
  connect(mapStateToProps, mapDispatchToProps)
)(ResearchWineriesPage);
